<template>
    <div class="approval_process_select_wrap">
        <ul>
            <li v-for="(item,index) in approvalNodeList" :key="index" class="approval_node_list" :class="'approval_node_list_' + item.type">
                <div class="process_title" v-text="item.name">发起</div>
                <div class="process_info_wrap">
                     <!-- 自动通过，自动拒绝-->
                    <p class="prompt_text" v-if="item.handle && item.handle.operation_type && item.handle.operation_type != 'manual_approval'"  v-text="item.handle.operation_type == 'auto_approve' ? '该节点将自动通过' :'该节点将自动拒绝'"></p>

                    <p class="prompt_text" v-if="item.handle_uids_info && item.handle_uids_info.length < 1 && item.handle && item.handle.type==='submitter_choice'" v-text="'请选择' + typeTitle(item.type) +'人'"></p>
                    <p class="prompt_text" v-if="item.handle_uids_info && item.handle_uids_info.length > 0" v-text="'已选' + item.handle_uids_info.length +'人'"></p>

                    <ul class="approve_user_list">
                        <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in item.handle_uids_info">
                            <div class="approve_user_item_info" @click="handleClickShowUserDetail(user.uid)">
                                <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                <span v-text="user.name"></span>
                                <!-- 审批人自选 或者 审批人不能自选，并且审批人为空时，指定成员没有选人-->
                                <i v-if="item.handle && (item.handle.type==='submitter_choice' ||  (item.handle.type!='submitter_choice' && item.handle.is_null_auto == 2 && item.handle.null_relate_id.length == 0 && item.handle.relate_id.length == 0))" @click.stop="handleDelApproversUsers(item,userIndex)" class="el-icon-error"></i>
                            </div>
                        </li>
                        <!--自选-->
                        <template v-if="item.handle && item.handle.type==='submitter_choice'">
                            <li class="add_approve_btn" v-if="(item.handle.is_single == 1 && item.handle_uids_info.length == 1) ? false : true">
                                <!--指定成员选择item.assign_users-->
                                <i class="el-icon-plus" v-if="item.handle&&item.handle.is_all_company==2" @click="handleClickSelectUser(item,'appoint','handle',item.assign_users)"></i>
                                <!--全部成员选择-->
                                <i class="el-icon-plus" v-else @click="handleClickSelectUser(item,'all','handle')"></i>
                            </li>
                        </template>

                        <!--如果审批人不能自选，并且审批人为空时，指定成员没有选人-->
                        <template v-if="item.handle && item.handle.type!='submitter_choice' && item.handle.is_null_auto == 2 && item.handle.null_relate_id.length == 0 && item.handle.relate_id.length == 0">
                            <li class="add_approve_btn">
                                <!--全部成员选择-->
                                <i class="el-icon-plus" @click="handleClickSelectUser(item,'all','handle')"></i>
                            </li>
                        </template>

                        <!--抄送人-->
                        <div class="ccusers_class" v-if="item.ccusers && item.ccusers.length > 0">
                             <p class="prompt_text" v-text="item.cc_uids_info.length < 1 ? '请选择抄送人' : '抄送' + item.cc_uids_info.length +'人'"></p>
                             <ul class="approve_user_list">
                                <li :key="userIndex" class="approve_user_item" :class="item.cc_uids_info.length>4 ? 'approve_user_small_item' : ''" v-for="(user,userIndex) in item.cc_uids_info">
                                    <div class="approve_user_item_info"  @click="handleClickShowUserDetail(user.uid)">
                                        <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                        <span v-text="user.name"></span>
                                        <i v-if="item.cc_uids.indexOf(user.uid) < 0 " @click.stop="handleDelCcUsers(item,userIndex)" class="el-icon-error"></i>
                                    </div>
                                </li>
                                <!--自选-->
                                 <template v-if="item.ccusers.find(find => find.type == 'submitter_choice')">
                                     <li class="add_approve_btn" v-if="(item.ccusers.find(find => find.type == 'submitter_choice').is_single == 1 && item.cc_uids_info.length > item.cc_uids.length) ? false : true ">
                                         <!--添加成员是单人，并且已经选择了一个则隐藏，否则显示-->
                                             <!--在全公司人员中选择-->
                                             <i class="el-icon-plus" @click="handleClickSelectUser(item,'all','cc')" v-if="item.ccusers.find(find => find.type == 'submitter_choice').is_all_company == 1"></i>
                                             <!--在指定成员中选择 item.ccusers.find(find => find.type == 'submitter_choice').relate_id-->
                                             <i class="el-icon-plus" @click="handleClickSelectUser(item,'appoint','cc',item.ccusers.find(find => find.type == 'submitter_choice').relate_id)" v-if="item.ccusers.find(find => find.type == 'submitter_choice').is_all_company == 2"></i>
                                     </li>
                                 </template>
                            </ul>
                        </div>
                    </ul>
                </div>
            </li>
        </ul>

        <userDetailDialog v-if="userDetailPopupShow"  :userDetailPopupShow.sync="userDetailPopupShow" :userId="userDetailId" />
        <!-- 人员选择 -->
        <UserSearchSelect :userSelectVisible.sync="userSelectVisible"  :userSelectTitle="'选择人员'" :selectType="'one'" @selectUserData="handleSelectUserData" v-if="userSelectVisible"/>
        <!--选择指定成员-->
        <van-popup :value.sync="userSelectAppointVisible"  round position="bottom" :style="{ height: '77%' }" @click-overlay="handleClosePopup" v-if="userSelectAppointVisible" >
            <div class="user_select_wrap">
                <div class="user_select_wrap_title">
                    <van-icon @click="handleClosePopup" name="arrow-left" />
                    <span class="title">选择人员</span>
                    <span class="confirm_text"></span>
                </div>

                <div class="user_select_content">
                    <div class="user_select_content_scroll">
                        <div class="list"  >
                            <div class="bottom">
                                <ul>
                                    <li v-for="item in userList" :key="item.uid" @click="handleClickUserItem(item)">
                                        <div>
                                            <span class="avatar_wrap">
                                               <img :src="item.avatar ? item.avatar : defaultImg" loading="lazy" alt="" />
                                            </span>
                                            <span>{{ item.name }}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>

    </div>
</template>
<script>
import userDetailDialog from "@/components/mComponents/userDetailDialog";
import UserSearchSelect from "@/components/mComponents/UserSearchSelect.vue";
import { GetUserList,SwapApprover } from "@/api/index.js"
export default {
    name: "approveProcessSelect",
    components: {
        userDetailDialog,
        UserSearchSelect
    },
    props: {
        approval_type:{
            type: String,
            default: '', // 审批类型
        },
        approval_node_list:{
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            approvalNodeList:[],
            userList:[],
            data:[],
            userDetailPopupShow: false,
            userDetailId: 0,
            userSelectVisible:false,
            changeItemInfo:null,
            userSelectAppointVisible:false,
            handleType:'',
        };
    },
    created() {
        this.set_approval_node_list(this.approval_node_list)

    },
    methods: {
        set_approval_node_list(data){
            data.forEach((item)=>{
                if(item.ccusers){
                    let  cc_uids_info = []
                    item.ccusers.forEach((child)=>{
                        cc_uids_info = cc_uids_info.concat(child.relate_user)
                        this.$set(child,'relate_id',child.relate_id.map(map => {return {name:map.relate_name,uid:map.relate_id,avatar:map.avatar}}))
                    })
                    this.$set(item,'cc_uids_info',cc_uids_info.filter((item, index, self) =>  index === self.findIndex((t) => (  t.uid === item.uid))))
                    this.$set(item,'cc_uids',item.cc_uids_info.map(map => {return map.uid}))
                    this.$set(item,'cc_handle_uids',item.cc_uids_info.map(map => {return map.uid}))
                }
                // 只可以选择的人员
                this.$set(item,'assign_users', item.handle.relate_id ? item.handle.relate_id.map(map => {return {name:map.relate_name,uid:map.relate_id,avatar:map.avatar}}) : [])

                // 系统规定选好的人员
                this.$set(item,'handle_uids_info',item.handle.relate_user)
                this.$set(item,'handle_uids',(item.handle.relate_user && item.handle.relate_user.length) ? item.handle.relate_user.map(map => {return map.uid}) : [])
                // 如果办理人|| 审批人为空时指定成员办理
                if(item.handle.is_null_auto == 2 && item.handle.relate_user.length == 0){
                    this.$set(item,'handle_uids_info', item.handle.null_relate_id ? item.handle.null_relate_id.map(map => {return {name:map.relate_name,uid:map.relate_id,avatar:map.avatar}}) : [])
                    this.$set(item,'handle_uids',(item.handle.null_relate_id && item.handle.null_relate_id.length) ? item.handle.null_relate_id.map(map => {return map.relate_id}) : [])
                }
            })
            this.approvalNodeList = data
        },
        // 当图片加载失败时，将 src 设置为默认图片
        handleError(event) {
            event.target.src = this.defaultImg;
        },
        // 选择人员
        handleClickSelectUser(item,type,handleType,userList){
            if(type == 'all'){
                this.userSelectVisible = true
            }else{
                this.userSelectAppointVisible = true
                this.userList = JSON.parse(JSON.stringify(userList))
            }

            this.handleType = handleType
            this.changeItemInfo = item
        },
        // 选择人员回调
        handleSelectUserData(data){
            if(this.handleType == 'cc'){
                this.handleSelectCcUsers(data, this.changeItemInfo)
            }else{
                this.handleSelectApproversUsers(data, this.changeItemInfo)
            }
        },
        // 指定成员取消
        handleClosePopup(){
            this.userSelectAppointVisible = false

        },
        // 指定成员选择
        handleClickUserItem(data){
            if(this.handleType == 'cc'){
                this.handleSelectCcUsers(data, this.changeItemInfo)
            }else{
                this.handleSelectApproversUsers(data, this.changeItemInfo)
            }
            this.userSelectAppointVisible = false
        },

        // 删除选择的人员
        handleDelApproversUsers(item,userIndex){
            item.handle_uids_info.splice(userIndex,1)
            item.handle_uids.splice(userIndex,1)
        },
        // 选择人员
        handleSelectApproversUsers(user,item){
            if (item.handle_uids_info.findIndex(list => list.uid === user.uid) > -1) return this.$toast(user.name + '已存在，不允许重复选择')
            if(item.type == 'approval' && item.handle.type == 'submitter_choice' && item.handle.consistency_type > 2 && user.uid == this.userInfo.user.id){
                let postData = {
                    node_id:item.handle.node_id,
                    approval_set_id:item.approval_set_id,
                    consistency_type:item.handle.consistency_type
                }
                SwapApprover(postData).then((res) => {
                    if (res.code == 200) {
                        let {approvers,isCompanyAdmin} = res.data
                        if(approvers && approvers.length){
                            let text =  item.handle.consistency_type == 3 ? '直属上级' :'部门负责人'
                            if(isCompanyAdmin){
                                this.$toast(`提交人与审批人为同一人且${text}为空，转交给公司管理员`)
                            }else{
                                this.$toast(`提交人与审批人为同一人，转交给${text}`)
                            }
                            approvers.forEach((list)=>{
                                if(item.handle_uids_info.findIndex(find => find.uid === list.uid) > -1){
                                    this.$toast(list.name + '已存在，不允许重复选择')
                                }else{
                                    item.handle_uids_info.push({
                                        uid: list.uid,
                                        name: list.name,
                                        avatar: list.avatar,
                                    })
                                    item.handle_uids.push(list.uid)
                                }
                            })
                        }else{

                        }
                    }
                });
            }else{
                item.handle_uids_info.push({
                    uid: user.uid,
                    name: user.name,
                    avatar: user.avatar,
                })
                item.handle_uids.push(user.uid)
            }
        },
        // 删除抄送人
        handleDelCcUsers(item,userIndex){
            item.cc_uids_info.splice(userIndex,1)
            item.cc_handle_uids.splice(userIndex,1)

        },
        // 选择抄送人
        handleSelectCcUsers(user, item){
          if (item.cc_uids_info.findIndex(item => item.uid === user.uid) > -1) return this.$toast(user.name + '已存在，不允许重复选择')
          item.cc_uids_info.push({
              uid: user.uid,
              name: user.name,
              avatar: user.avatar,
          })
          item.cc_handle_uids.push(user.uid)
        },
        typeTitle(type) {
            let string = ''
            switch (type) {
                case 'start':
                    string = '抄送'
                    break
                case 'approval':
                    string = '审批'
                    break
                case 'conduct':
                    string = '办理'
                    break
                case 'end':
                    string = '抄送'
                    break
            }
            return string
        },

        // 校验每个审批节点是否选择了人
        handleClickPublish(){
            let flag = true
            this.approval_node_list.forEach((item)=>{
                if(item.type != 'start' && item.type != 'end'){
                    if(!item.handle_uids || item.handle_uids.length == 0 && flag){
                        this.$toast(`请选择${item.name}节点的人员`)
                        flag = false
                    }
                }
            })
            if(flag == false){
                return false
            }
        },
        // 查看用户详情
        handleClickShowUserDetail(userId) {
            this.userDetailId = userId;
            this.userDetailPopupShow = true;
        },
    },
};
</script>
<style lang="scss" scoped>
.approval_process_select_wrap{
    .ccusers_class{
        width: 100%;
    }
    width: 100%;
    ul{
        width: 100%;
        li.approval_node_list{
            width: 100%;
            padding-left: 24px;
            padding-bottom: 12px;
            box-sizing: border-box;
            position: relative;
            &:before{
                width: 16px;
                height: 16px;
                border-radius: 50%;
                content: ' ';
                left: 0;
                top: 0;
                position: absolute;
                border:4px solid rgba(191, 191, 191, 1);
                background: #fff;
            }
            &:after{
                width: 1px;
                height: 100%;
                position: absolute;
                left: 7px;
                top: 0;
                border: 1px dashed rgba(232, 232, 232, 1);
                content: ' ';
            }
            &:last-child:after{
              display: none;
            }
            &.approval_node_list_start{
                &:before{
                    border:4px solid rgba(25, 144, 255, 1);
                }
            }
            &.approval_node_list_approval{
                &:before{
                    border:4px solid rgba(251, 173, 19, 1);
                }
            }
            &.approval_node_list_conduct{
                &:before{
                    border:4px solid rgba(121, 72, 234, 1);
                }
            }
            &.approval_node_list_end{
                &:before{
                    border:4px solid rgba(82, 196, 27, 1);
                }
            }
            .process_title{
                width: 100%;
                line-height: 18px;
                color: rgba(51, 51, 51, 1);
                font-size: 12px;
            }
            .process_info_wrap{
                width: 100%;
                .prompt_text{
                    font-size: 12px;
                    color: rgba(102, 102, 102, 1);
                    line-height: 18px;
                    margin-top: 2px;
                }
                .approve_user_list {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    margin-top: 8px;
                    .approve_user_item {
                        min-width: 75px;
                        border-radius: 16px;
                        box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.08);
                        padding: 0 10px 0 2px;
                        position: relative;
                        margin-right: 16px;
                        margin-bottom: 8px;
                        line-height: 28px;
                        cursor: pointer;
                        overflow: initial;
                        .approve_user_item_info{
                            display: flex;
                            align-items: center;
                        }
                        .head_img {
                            width: 24px;
                            height: 24px;
                            border-radius: 50%;
                            margin-right: 4px;
                        }
                        .el-icon-error {
                            position: absolute;
                            top: -7px;
                            right: -7px;
                            color:rgba(191, 191, 191, 1);
                            cursor: pointer;
                            display: block;
                            font-size: 14px;
                        }
                        .el-icon-right {
                            position: absolute;
                            top: 10px;
                            right: -18px;
                        }
                        &.approve_user_small_item{
                            width: auto;
                            min-width: auto;
                            padding: 0;
                            width: 26px;
                            height: 26px;
                            border: 1px solid #fff;
                            border-radius: 50%;
                            margin-left: -8px;
                            margin-right: 0;
                            box-sizing: border-box;
                            cursor: pointer;
                            &:first-child{
                                margin-left: 0;
                            }
                            .el-icon-error{
                                display: none;
                            }
                            span{
                                display: none;
                            }
                            .head_img{
                                margin-right: 0;
                            }
                            &:hover{
                                z-index: 1;
                                 .el-icon-error{
                                   display: block;
                                 }
                            }
                        }

                    }
                    .add_approve_btn {
                        width: 28px;
                        height: 28px;
                        text-align: center;
                        line-height: 28px;
                        box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.08);
                        cursor: pointer;
                        border-radius: 50%;
                        margin-bottom: 8px;
                        i.el-icon-plus {
                            display: block;
                            width: 28px;
                            height: 28px;
                            line-height: 28px;
                            color: rgba(25, 144, 255, 1);
                        }
                    }
                }
            }

        }
    }

}


.user_select_wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    .user_select_wrap_title {
        flex-shrink: 0;
        padding: 0 16px;
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .van-icon-arrow-left {
            font-size: 24px;
            color: rgba(102, 102, 102, 1);
        }
        .title {
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
        }
        .confirm_text {
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(41, 144, 240, 1);
        }
    }

    .user_select_content {
        flex: 1;
        padding: 10px 0;
        position: relative;
        overflow: hidden;
        .user_select_content_scroll{
            overflow-y: auto;
            width: 100%;
            height: 100%;
        }
        ul {
            padding: 0 16px;
            li {
                padding: 8px 0;
                display: flex;
                align-items: center;
                gap: 12px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
                div{
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    flex: 1;
                }
                .avatar_wrap {
                    display: inline-block;
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 50%;
                    }
                }

                &:active {
                    background-color: rgba(217, 217, 217, 0.2);
                }
            }
        }
    }
    .van-index-bar__sidebar{
        position: absolute;

    }
}
</style>

